import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Pagination } from '$core/models/pagination';
import {
  Notification,
  NotificationCount,
  NotificationsParams,
  NotificationTopic,
  NotificationTopicSubscribeBody,
} from '$modules/personal/notifications/model/notifications-model';

@Injectable({
  providedIn: 'root',
})
export class NotificationsHttpService {
  protected apiRoute = '/messages';
  protected apiVersion = '/v1';

  constructor(private readonly http: HttpClient) {}

  public getNotificationsIndex(options: {
    url?: string;
    params?: NotificationsParams;
  }): Observable<Pagination<Notification>> {
    if (options.url) {
      return this.http.get<Pagination<Notification>>(options.url);
    }

    return this.http.get<Pagination<Notification>>(
      `${this.apiVersion}${this.apiRoute}`,
      { params: options.params }
    );
  }

  public getNotificationById(id: string): Observable<Notification> {
    return this.http.get<Notification>(
      `${this.apiVersion}${this.apiRoute}/${id}`
    );
  }

  public makeAllAsRead(
    params?: NotificationsParams
  ): Observable<Pagination<Notification>> {
    return this.http.post<Pagination<Notification>>(
      `${this.apiVersion}/read-messages`,
      {},
      { params }
    );
  }

  public getUnreadNotificationsCount(): Observable<NotificationCount> {
    return this.http.get<NotificationCount>(
      `${this.apiVersion}/count-unread-messages`
    );
  }

  public getNotificationsSettings(options: {
    url?: string;
    params?: NotificationsParams;
  }): Observable<Pagination<NotificationTopic>> {
    if (options.url) {
      return this.http.get<Pagination<NotificationTopic>>(options.url);
    }

    return this.http.get<Pagination<NotificationTopic>>(
      `${this.apiVersion}/topics`,
      { params: options.params }
    );
  }

  public subscribeToTopic(
    body: NotificationTopicSubscribeBody
  ): Observable<Pagination<NotificationTopic>> {
    return this.http.post<Pagination<NotificationTopic>>(
      `${this.apiVersion}/topics`,
      body
    );
  }

  public unsubscribeToTopic(
    id: string
  ): Observable<Pagination<NotificationTopic>> {
    return this.http.delete<Pagination<NotificationTopic>>(
      `${this.apiVersion}/topics/${id}`
    );
  }
}
